module.exports = __webpack_public_path__ + "static/images/containers/Landing/images/landing-slide-bg-pattern.722bb99e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/images/landing-slide-bg-pattern.png
// module id = 3168
// module chunks = 11